// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SaveCart: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 54"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M45.7 7.2H30c-.8 0-1.4.6-1.4 1.4S29.2 10 30 10h14.3v40.5H3.7V9.9H18c.8 0 1.4-.6 1.4-1.4s-.6-1.3-1.4-1.3H2.4c-.8 0-1.4.6-1.4 1.4v43.3c0 .8.6 1.4 1.4 1.4h43.3c.8 0 1.4-.6 1.4-1.4V8.6c-.1-.8-.7-1.4-1.4-1.4z"/><path d="M18.6 23.9c-.5-.5-1.4-.5-1.9 0s-.5 1.4 0 1.9l6 6c.3.3.6.4 1 .4s.7-.1 1-.4l6-6c.5-.5.5-1.4 0-1.9s-1.4-.5-1.9 0l-3.7 3.7V2.1c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v25.5l-3.7-3.7z"/></svg>;
};

export default React.memo(SaveCart);
